{
  "presets": [
    {
      "key": "is_master",
      "label": "Это мастер процесс",
      "formula": "!isset(this.field_workflow)"
    },
    {
      "key": "is_not_master",
      "label": "Это не мастер процесс",
      "formula": "isset(this.field_workflow)"
    },
    {
      "key": "process_has_child",
      "label": "Этот процесс содержит дочерние процессы",
      "formula": "count(this.field_child_process) != 0"
    }
  ]
}
